import React, { useEffect, useState } from 'react';
import settings from '../../../settings';
import { updateUserDataAfterLogin } from '../../../store/calls';
import api from '../../../store/api';
import {
	addErrorAlert,
	toggleGlobalLoader,
} from '../../../store/calls/alertLoadingDispatch';

export const handleLinkedinLoginRequest = (
	code,
	redirectionURI,
	successCallback,
	failureCallback
) => {
	return api
		.post('/auth/linkedin-login/', { code, redirectionURI })
		.then((res) => {
			let token = res.data.tokens.access;
			let userData = updateUserDataAfterLogin(token);
			return successCallback && successCallback(userData);
		})
		.catch((err) => {
			console.error(err)
			addErrorAlert(
				'There was a problem with this request. Please try one of our other login methods or try again in a few seconds.'
			);
			return failureCallback && failureCallback(err);
		})
};

export function LinkedinSignInButton({
	prompt,
	redirectionURI,
	successCallback,
	failureCallback,
	className
}) {
	const linkedinRedirectUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${settings.linkedinAuthClientId}&redirect_uri=${redirectionURI}&scope=r_liteprofile,r_emailaddress`;
	const [loading, setLoading] = useState(false);

	// listen for code on return page where the button is hosted
	useEffect(() => {
		let linkedinAuthCode = new URLSearchParams(window.location.search).get(
			'code'
		);
		if (linkedinAuthCode) {
			setLoading(true);
			toggleGlobalLoader(true);
			handleLinkedinLoginRequest(
				linkedinAuthCode,
				`${window.location.origin}${window.location.pathname}`,
				successCallback,
				failureCallback
			).finally(() => {
				toggleGlobalLoader(false);
				setLoading(false);
			});
		}
	}, []);

	return (
			<a href={linkedinRedirectUrl} className="is-fullwidth">
				{loading ? (
					<button type="button" className={`button is-loading ${className}`}>
						Loading
					</button>
				) : (
					<button type="button" className={`button ${className}`}>
						<i className="fab fa-linkedin mr-3 has-text-primary" />
						{prompt || 'Login with Linkedin'}
					</button>
				)}
			</a>
	);
}

export default LinkedinSignInButton;
